enum SearchPlatforms {
  Pixabay = 'pixabay',
  Pexels = 'pexels',
  Unsplash = 'unsplash',
}

export default SearchPlatforms;
